<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 609.35 1078.02"
  >
    <rect x="260.38" y="857" width="86.63" height="221" fill="#66420e" />
    <polyline
      points="304.65 0 214.37 198.07 243.35 198.07 169.23 360.69 198.5 360.69 101.57 573.36 130.19 573.36 0 859 304.7 859"
      fill="#4b7641"
    />
    <polyline
      points="304.7 0 394.98 198.07 365.99 198.07 440.12 360.69 410.85 360.69 507.78 573.36 479.15 573.36 609.35 859 304.65 859"
      fill="#2f5f35"
    />
    <rect x="313.12" y="857.02" width="35.02" height="221" fill="#432b09" />
  </svg>
</template>
